module.exports = __webpack_public_path__ + "img/subBanner11.dc2e14b3.png";